<template>
  <div class="provide mb-4">
    <three-dots class="dots"/>
    <div class="title">Спецпредложение</div>
    <div class="konsultation d-flex align-items-center justify-content-md-center">
      <img src="@/assets/bgdots.png" class="bgDots" alt="">
      <div class="price">
        <p class="mt-2">Стоимость консультации</p>
        <span><span class="numbers">{{price2}}</span> евро</span>
        <p>Длительность консультации</p>
        <span><span class="numbers">{{time2}}</span> мин</span>
      </div>
      <div class="format">
        <h1 class="format-title">Формат консультаций:</h1>
        <div class="format-skype d-flex align-items-center"><skype/> Skype</div>
        <p class="format-skype-discription" v-scroll-to="'#questions'" style="cursor: pointer"><u>Как проходит консультация по Skype?</u></p>
        <p class="format-discription">Не оставайтесь со своими проблемами один на один. Консультация профессионального психолога - первый шаг к эффективному решению ситуации.</p>
        <div class="d-flex align-items-center">
          <button class="button" @click="$router.push('/services')">Записаться <under-arrow/></button>
          <div class="format-contact-info">
            <div class="d-flex align-items-center">
              <viber/>
              <div class="d-flex align-content-center flex-wrap">
                <p>Viber, WhatsApp:</p>
                <a href="https://wa.me/393200946598" target="_blank" class="line-height-1"><span class="numbers"><u><span class="Raleway">+</span>393200946598</u></span></a>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2 line-height-1">
              <mail class="line-height-1"/>
              <a href="mailto:svetlanarambelli@gmail.com"><span class="line-height-1">svetlanarambelli@gmail.com</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  import UnderArrow from '@/components/icons/UnderArrow';
  import Viber from '@/components/icons/Viber';
  import Mail from '@/components/icons/Mail';
  import Skype from '@/components/icons/Skype';
  import { mapActions, mapState } from 'vuex';
  export default {
    name: "Provide",
    components: {ThreeDots, UnderArrow, Mail, Viber, Skype},
    data() {
      return {
        loading: true,
        price2: null,
        time2: null,
      }
    },
    async mounted() {
      await this.loadDetails()
    },
    computed: {
      ...mapState('price', ['skype', 'consultation', 'threeDays'])
    },
    methods: {
      ...mapActions('price', [
        'fetchSkypeConsultation', 'fetchChatConsultation', 'fetchThreeDaysConsultation',
        'skypeConsultation', 'chatConsultation', 'threeDaysConsultation']),
      async loadDetails() {
        this.loading = true
        await this.fetchSkypeConsultation()
        this.price2 = this.skype.price2
        this.time2 = this.skype.time2
        this.loading = false
      },
    }
  }
</script>

<style lang="scss">
  .provide {
    position: relative;
    padding-left: 45px;
    padding-right: 45px;
    .dots {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    title {
      margin-bottom: 64px;
    }
  }
  .konsultation:after {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background: #fff;
    border: 1px solid #7e7e7e;
    content: '';
    z-index: 1;
    left: -20px;
    border-radius: 9px;
    bottom: -20px;
  }
  .konsultation {
    position: relative;
    max-width: 720px;
    margin: 0 auto;
    z-index: 2;
    .bgDots {
      position: absolute;
      z-index: 2;
      right: -45px;
      top: -45px;
      max-width: 134px;
      width: 100%;
    }
    .price {
      width: 37%;
      font-family: 'Raleway', sans-serif;
      padding: 40px 24px;
      border: 4px solid #e8f4ff;
      border-top-left-radius: 9px;
      border-bottom-left-radius: 9px;
      position: relative;
      z-index: 3;
      background: #fff;
      p {
        font-size: 17px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1f1f1f;
        margin-top: 32px;
        margin-bottom: 16px;
      }
      span {
        font-size: 24px;
        margin: 0;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #5ec8f5;
      }
    }
  }
  .line-height-1 {
    line-height: 1 !important;
  }
  .format {
    width: 63%;
    position: relative;
    z-index: 3;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    font-family: 'Raleway', sans-serif;
    background-color: #ecf6f8;
    padding:36px 35px 35px;
    &-title {
      font-size: 17px;
      color: #1f1f1f;
    }
    &-discription {
      font-size: 14px;
      color: #7e7e7e;
      margin-top: 8px;
    }
    &-skype {
      margin-bottom: 8px;
      svg {
        margin-right: 8px;
      }
    }
    &-skype-discription {
      font-size: 10px;
      color: #7e7e7e;
      margin-bottom: 0;
      text-decoration: underline;
    }
    .button {
      width: 181px;
      height: 48px;
      border-radius: 9px;
      background-color: #55cce7;
      margin-right: 32px;
      font-size: 17px;
      font-weight: 600;
      border: none;
      color: #ffffff;
      svg {
        transform: rotate(-90deg);
        margin-left: 15px;
      }
    }
    .format-contact-info {
      div {
        svg {
          margin-right: 8px;
        }
        p {
          margin: 0;
          font-size: 10px;
          width: 100%;
          line-height: 1;
          color: #1f1f1f;
        }
        span {
          width: 100%;
          font-size: 10px;
          font-weight: 600;
          line-height: 1.3;
          color: #1f1f1f;
        }
      }
    }
  }
  @media screen and (max-width: 930px) {
    .provide {
      margin-top: 100px;
    }
  }
  @media screen and (max-width: 800px) {
    .provide {
      padding-right: 25px;
      padding-left: 25px;
    }
    .konsultation {
      .bgDots {
        right: -30px;
        top: -30px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .provide {
      padding-right: 25px;
      padding-left: 25px;
    }
    .konsultation:after {
      display: none;
    }

    .konsultation.d-flex {
      flex-wrap: wrap;
      max-width: 400px;
      .bgDots {
        right: -45px;
        top: -45px;
        display: none;
      }
      .price {
        width: 100%;
        border-top-right-radius: 9px;
        border-bottom-left-radius: 0px;
        text-align: center;
      }
      .format {
        width: 100%;
        &-skype {
          justify-content: center;
        }
        border-bottom-left-radius: 9px;
        border-top-right-radius: 0px;
      }
      .button {
        margin-right: 15px;
      }
    }
  }
  @media screen and (max-width: 550px){
    .provide {
      .title {
        margin-bottom: 32px;
      }
    }
  }
  @media screen and (max-width: 480px) {
    .konsultation {
      .format {
        text-align: center;
        .format-title {
          text-align: center;
        }
        .format-contact-info {
          display: none;
        }
        .format-discription {
          margin-top: 20px;
        }
        .button {
          margin-right: auto;
          margin-left: auto;
          margin-top: 24px;
        }
      }
    }
  }
</style>